import React from "react";
import * as Redux from 'react-redux';

import TopMenu from './TopMenu';

export class Logout extends React.Component {
	componentDidMount() {
		const {dispatch} = this.props;
	}

	render() {
		document.title = "Logout";
		window.location = process.env.REACT_APP_YGL_LEGACY_APP_DOMAIN + "auth/logout";

		return (
			<div>
				<TopMenu />
				<div className="not-found-page">
					<h2>Logout Successful</h2>
				</div>
			</div>
		);
	}
}

export default Redux.connect(
	(state) => {
		return state;
	}
)(Logout);


// WEBPACK FOOTER //
// ./src/components/Logout.js